import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import caretDownSvg from 'resources/svg/icons/caret-down.svg'

export const Wrapper = styled.div`
  ${props => props.theme.css.container};
  min-height: 70vh;
  margin-bottom: 40px;

  h2 {
    margin: 14px auto;
    font: ${font('default', 'bold', '20px/1.2')};
    ${bp('sm')`
      padding: 0 20px;
    `}
  }

  .reviews {
    &__content {
      margin-top: 10px;
      ${bp('sm')`
        flex-wrap: wrap;
      `}
    }
  }
`

export const Heading = styled(FlexWrapper)`
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  ${bp('sm')`
    flex-wrap: wrap;
    margin-bottom: 20px;
  `}

  h1 {
    ${props => props.theme.css.heading2};
  }
`

export const Sidebar = styled.div`
  width: 15%;
  min-width: 200px;
  padding-right: 5%;
  margin-right: 5%;
  border-right: 1px solid ${props => props.theme.palette.general.greyLight};
  ${bp('sm')`
    width: 100%;
    border: none;
    padding-right: 0;
    margin: 0 0 20px 0;
  `}

  .reviews {
    &__rating {
      padding-left: 20px;
      ${bp('sm')`
        padding-left: 0;
        margin: auto;
        max-width: 200px;
      `}

      h3 {
        font: ${font('default', 'bold', '16px/1.2')};
      }

      &-stars {
        padding: 5px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        .react-rater-star {
          width: 11px;
          height: 11px;
          background-size: 10px;
        }

        span {
          font: ${font('default', 'light', '14px/1.2')};
        }
      }
    }
  }
`

export const Content = styled.div`
  width: 70%;
  ${bp('sm')`
    width: 100%;
  `}

  h2,
  .reviews__toolbar {
    max-width: 600px;
    padding: 0 20px;

    label {
      display: block;
      margin-bottom: 10px;
    }

    select {
      appearance: none;
      background: transparent url(${caretDownSvg}) no-repeat;
      background-size: 13px;
      background-position-x: 98%;
      background-position-y: 8px;
      border: 1px solid ${props => props.theme.palette.general.greyDark};
      border-radius: 6px;
      padding: 10px 30px 10px 10px;
      min-width: 50%;
    }
  }

  .reviews__toolbar {
    margin: auto;
  }

  .review__title {
    margin-top: 10px;
  }
`
